import { exchangeContactApi } from "@/core/data/api";

export default async (id) => {
  return await exchangeContactApi.saveExchangeContact(id);
};
